<template>
  <div >
    <mall-header></mall-header>
    <!-- 订单列表 -->
    <div class="guide-content"  ></div>
    <div class="orderList-header">
      <nav-Menu></nav-Menu>
      <div style="visibility:visible">
          <div class="orderListContentData" >
              <el-tabs v-model="activeName" @tab-click="handleClick" class="orderList-el-tabs"  v-loading="AllLoading">
                  <el-tab-pane label="全部订单"  name="allOrder" >
                      <div v-if="orderList.length || !isData"  >
                          <el-form ref="form"  @submit.native.prevent>
                              <el-select v-model="statusValue"   :style="'width: 200px;height: 32px;background: #FFFFFF;border: 0px solid #DDDDDD;border-radius: 2px;'" :popper-append-to-body='false' @change="selectStatusChanged" class="orderlist-content-select" >
                                  <el-option
                                    v-for="item in statusOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                  </el-option>
                              </el-select>
                              <el-select v-model="dateOrderValue"  label="全部订单"  :popper-append-to-body='false' @change="selectTimeChanged" class="orderlist-content-select" style=" margin-left: 10px;width: 200px;height: 32px;background: #FFFFFF;border: 0px solid #DDDDDD;border-radius: 2px;">
                                <el-option
                                    v-for="item in timeOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                  </el-option>
                              </el-select>
                              <el-select  v-model="typeValue"  style="margin-left: 10px;width: 160px;height: 32px;background: #FFFFFF;border: 0px solid #DDDDDD;border-radius: 2px;"  label="全部活动类型"  :popper-append-to-body='false' @change="selectTypeChanged" class="orderlist-content-select" >
                                  <el-option
                                    v-for="item in typeOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                              </el-select>
                              <el-input id="allPlaceholder"
                                  v-model="searchContent"
                                  @keydown.enter="callFun"
                                  placeholder="商品名称/订单编号"
                                  size="medium"
                                  class="orderList-shop-search">
                                  <i class="el-input__icon el-icon-search" slot="suffix" @click="searchOrder"/>
                              </el-input>
                            </el-form>
                        </div>
                        <div  v-if="!orderList.length "  v-loading="AllLoading">
                          <div   style="margin-top: 100px; margin-right: 30px;margin-bottom: 100px;">
                            <img src="../../static/images/空.png" alt="" style="margin:0 auto;  display:block;">
                            <p class="orderList-defulat-font" >哎呀，什么都没有 T_T</p>
                          </div>
                      </div>
                      <div v-if="orderList.length " >
                          <div v-for="(datas, index) in orderList" :key="index"   >
                              <div  style=" width: 920px;height: 40px;background: #F6F6F6;margin-top: 20px;border: 0px solid #EEEEEE;"  >
                                  <span  style="margin-left: 30px;position: absolute;margin-top: 10px;font-size: 14px;">{{datas.createTime}} </span>
                                  <span style=" margin-left: 215px;position: absolute; margin-top: 10px;font-size: 14px;">订单编号：<span style="color:#333;font-size: 14px;">{{datas.orderNo}}</span> </span>
                                  <img src="../../static/images/时间.png" v-if="datas.orderStatus==1" style="    margin-right: 230px;margin-top: 12px;float: right;"/>
                                  <span class="orderList-countDownTime"  v-if="datas.orderStatus==1" :style="datas.countDownTime.indexOf('时')<0?'margin-right: 135px':''">{{datas.countDownTime}} </span>
                                  <span class="waitPay" v-if="datas.orderStatus=='1'">{{datas.orderStatus_dictText}} </span>
                                  <span class="paySUC" v-if="datas.orderStatus=='2'">{{datas.orderStatus_dictText}} </span>
                                  <span class="colosePay" v-if="datas.orderStatus=='3'">{{datas.orderStatus_dictText}} </span>
                              </div>
                          <div >
                            <table class="orderList-table"  cellspacing="0" cellpadding="0" >
                              <tr style="height: 110px;border: 0px solid #EEEEEE; "  v-for="(data, i) in datas.orderDetails" :key="i" >
                                <td width=" 600px" style="border: 1px solid #EEEEEE;">
                                  <div style="float:left">
                                      <img :src="datas.orderDetails[0].itemImgUrl"  @click="openGoodsDetails(data.serviceItemId)" class="orderList-table-td-img" >
                                      <el-tooltip placement="right"  :open-delay="500"  :disabled="allTips" :content='data.serviceItemName' >
                                        <span  class="orderList-table-td-font" @mouseenter="allTipsFun($event)"  @click="openGoodsDetails(data.serviceItemId)">{{data.serviceItemName}}</span>
                                      </el-tooltip>
                                      <span class="orderList-table-td-dj" >￥{{data.unitPrice}}</span>

                                      <span class="orderList-table-td-num" >{{data.quantity}} 份</span>
                                  </div>
                                </td>
                                <td width=" 150px"  style="border: 1px solid #EEEEEE;    text-align: center;" >
                                  <div>
                                    <span class="orderList-table-td-money" >￥{{data.amount}}</span>
                                    <span class="orderList-table-td-type" >{{datas.type_dictText}}</span>
                                  </div>
                                </td>
                                <td  width=" 170px" style="border: 1px solid #EEEEEE;">
                                  <div class="orderList-table-td-div" >
                                    <div><button class="orderList-table-td-button1" @click="toPay(datas.id)"  v-if="datas.orderStatus=='1'">去付款</button></div>
                                    <span class="orderList-table-td-view"   @click="viewOrder(datas.id)" >查看详情</span>
                                    <span class="orderList-table-td-canle"  @click="canlOrder(datas.id)" v-if="datas.orderStatus=='1'">取消订单</span>
                                    <span class="orderList-table-td-agin" @click="againOrder(datas)" v-if="datas.orderStatus !='1'">再次购买</span>
                                  </div>
                                </td>
                              </tr>
                            </table>
                          </div>
                      </div>
                </div>

                  </el-tab-pane>
                  <!-- <div v-if="orderList.length>0" id="orderAllPage">
                      <el-pagination background
                        style="margin-top: 20px; float: right;margin-right: 0px;    margin-bottom: 20px;"
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :current-page="querydata.pageNo"
                          :page-sizes="[4, 10, 20, 40]"
                          :page-size="querydata.pageSize"
                          layout="total, sizes, prev, pager, next"
                          :total="orderTotal">
                      </el-pagination>
                </div>  -->
                  <el-tab-pane label="待付款" class="wait-el-tab"   name="waitPay">
                      <div v-if="!isWaitData" >
                          <el-select v-model="WaitOrderValue" label="全部订单" @change="selectTimeChanged1" class="orderlist-content-select" style=" width: 200px;height: 32px;background: #FFFFFF;border: 0px solid #DDDDDD;border-radius: 2px;" >
                          <el-option
                              v-for="item in WaitTimeOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                              </el-option>
                          </el-select>
                          <el-select  v-model="WaitTypeValue" label="全部活动类型" @change="selectTypeChanged1" class="orderlist-content-select" style="margin-left: 10px;width: 160px;height: 32px;background: #FFFFFF;border: 0px solid #DDDDDD;border-radius: 2px;">
                            <el-option
                              v-for="item in WaitTypeOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                              </el-option>
                          </el-select>
                          <el-input
                            v-model="searchContent1"
                            placeholder="商品名称/订单编号"
                            size="medium"
                            class="orderList-shop-search">
                            <i class="el-input__icon el-icon-search" slot="suffix" @click="searchOrder1()"/>
                          </el-input>
                        </div>
                        <div  v-if="!orderList1.length" v-loading="waitLoading" >
                            <div   style="margin-top: 100px; margin-right: 30px;margin-bottom: 100px;">
                              <img src="../../static/images/空.png" alt="" style="margin:0 auto;  display:block;">
                              <p class="orderList-defulat-font" >哎呀，什么都没有 T_T</p>
                            </div>
                        </div>
                      <div v-if="orderList1.length" v-loading="waitLoading">
                        <div v-for="(datas, index) in orderList1" :key="index"  >
                            <div  style=" width: 920px;height: 40px;background: #F6F6F6;margin-top: 20px;border: 0px solid #EEEEEE;" >
                              <span  style="margin-left: 30px;position: absolute;margin-top: 10px;font-size: 14px;">{{datas.createTime}} </span>
                              <span style=" margin-left: 215px;position: absolute; margin-top: 10px;font-size: 14px;">订单编号：<span style="color:#333;font-size: 14px;">{{datas.orderNo}}</span> </span>
                              <img src="../../static/images/时间.png" v-if="datas.orderStatus==1" style="    margin-right: 230px;margin-top: 12px;float: right;"/>

                              <span style=" margin-right: -145px;margin-top: 10px;float: right;color: #FF620D;font-size: 14px;font-family: PingFang SC;font-weight: 500;"  v-if="datas.orderStatus==1">{{datas.countDownTime}} </span>
                              <span class="waitPay" v-if="datas.orderStatus=='1'">{{datas.orderStatus_dictText}} </span>
                              <span class="paySUC" v-if="datas.orderStatus=='2'">{{datas.orderStatus_dictText}} </span>
                              <span class="colosePay" v-if="datas.orderStatus=='3'">{{datas.orderStatus_dictText}} </span>
                            </div>
                            <div>
                              <table class="orderList-table" style="width: 100%;height: 110px;background: #FFFFFF;border: 1px solid #EEEEEE;" v-if="orderList1.length">
                                <tr style="height: 110px;border: 1px solid #EEEEEE;" >
                                  <td width=" 600px" style="border: 1px solid #EEEEEE;" >
                                    <div style="float:left">
                                        <img :src="datas.orderDetails[0].itemImgUrl" @click="openGoodsDetails(datas.orderDetails[0].serviceItemId)" class="orderList-table-td-img" >
                                        <el-tooltip placement="right"  :open-delay="500"  :disabled="showTip1" :content='datas.orderDetails[0].serviceItemName' >
                                          <span  class="orderList-table-td-font" @mouseenter="showTips1($event)"  @click="openGoodsDetails(datas.orderDetails[0].serviceItemId)">{{datas.orderDetails[0].serviceItemName}}</span>

                                        </el-tooltip>
                                        <span class="orderList-table-td-dj" >￥{{datas.orderDetails[0].unitPrice}}</span>

                                        <span class="orderList-table-td-num" >{{datas.orderDetails[0].quantity}} 份</span>
                                    </div>
                                  </td>
                                  <td width=" 150px" style="border: 1px solid #EEEEEE;text-align: center;" >
                                      <span class="orderList-table-td-money" >￥{{datas.orderDetails[0].amount}}</span>
                                      <span class="orderList-table-td-type" >{{datas.type_dictText}}</span>
                                  </td>
                                  <td  width=" 170px"  style="border: 1px solid #EEEEEE;">
                                    <div class="orderList-table-td-div" >
                                    <div><button class="orderList-table-td-button1" @click="toPay(datas.id)"  v-if="datas.orderStatus=='1'">去付款</button></div>
                                      <span class="orderList-table-td-view"   @click="viewOrder(datas.id)" >查看详情</span>
                                      <span class="orderList-table-td-canle"  @click="canlOrder(datas.id)" v-if="datas.orderStatus=='1'">取消订单</span>
                                      <span class="orderList-table-td-agin"  @click="againOrder(datas.id)" v-if="datas.orderStatus !='1'">再次购买</span>
                                    </div>
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </div>
                        </div>

                  </el-tab-pane>
                  <el-tab-pane label="已付款" class="wait-el-tab"    name="endPay">

                      <div v-if="!isEndData" >
                          <el-select v-model="payOrderValue" width=" 67%" label="全部订单" @change="selectTimeChanged2" class="orderlist-content-select" style=" width: 200px;height: 32px;background: #FFFFFF;border: 0px solid #DDDDDD;border-radius: 2px;" >
                          <el-option
                              v-for="item in payTimeOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                              </el-option>
                          </el-select>
                          <el-select  v-model="payTypeValue" width=" 67%" label="全部活动类型" @change="selectTypeChanged2" class="orderlist-content-select" style="margin-left: 10px;width: 160px;height: 32px;background: #FFFFFF;border: 0px solid #DDDDDD;border-radius: 2px;">
                            <el-option
                              v-for="item in payTypeOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                              </el-option>
                          </el-select>
                          <el-input
                            v-model="searchContent2" placeholder="商品名称/订单编号" size="medium" class="orderList-shop-search">
                            <i class="el-input__icon el-icon-search" slot="suffix" @click="searchOrder2()"/>
                          </el-input>
                      </div>
                      <div  v-if="!orderList2.length && !isEndData" v-loading="payLoading">
                          <div   style="margin-top: 100px; margin-right: 30px;margin-bottom: 100px;">
                              <img src="../../static/images/空.png" alt="" style="margin:0 auto;  display:block;">
                              <p class="orderList-defulat-font" >哎呀，什么都没有 T_T</p>
                          </div>
                      </div>
                      <div v-if="orderList2.length" v-loading="payLoading">
                          <div v-for="(datas, index) in orderList2" :key="index"   >
                              <div  style="width: 920px;height: 40px;background: #F6F6F6;margin-top: 20px;border: 0px solid #EEEEEE;" v-if="orderList2.length">
                                <span  style="margin-left: 30px;position: absolute;margin-top: 10px;font-size: 14px;">{{datas.createTime}} </span>
                                <span style=" margin-left: 215px;position: absolute; margin-top: 10px;font-size: 14px;">订单编号：<span style="color:#333;font-size: 14px;">{{datas.orderNo}}</span> </span>

                                <span class="waitPay" v-if="datas.orderStatus=='1'">{{datas.orderStatus_dictText}} </span>
                                <span class="paySUC" v-if="datas.orderStatus=='2'">{{datas.orderStatus_dictText}} </span>
                                <span class="colosePay" v-if="datas.orderStatus=='3'">{{datas.orderStatus_dictText}} </span>
                          </div>
                          <div>
                              <table class="orderList-table" style="width: 920px;height: 110px;background: #FFFFFF;border: 1px solid #EEEEEE;" v-if="orderList2.length">
                                  <tr style="height: 110px;border: 1px solid #EEEEEE;" >
                                      <td width=" 600px" style="border: 1px solid #EEEEEE;" >
                                          <div style="float:left">
                                            <img :src="datas.orderDetails[0].itemImgUrl" @click="openGoodsDetails(datas.orderDetails[0].serviceItemId)" class="orderList-table-td-img" >
                                            <el-tooltip placement="right"  :open-delay="500"  :disabled="showTip2" :content='datas.orderDetails[0].serviceItemName' >
                                              <span  class="orderList-table-td-font" @mouseenter="showTips2($event)"  @click="openGoodsDetails(datas.orderDetails[0].serviceItemId)">{{datas.orderDetails[0].serviceItemName}}</span>

                                            </el-tooltip>
                                            <span class="orderList-table-td-dj" >￥{{datas.orderDetails[0].unitPrice}}</span>

                                            <span class="orderList-table-td-num" >{{datas.orderDetails[0].quantity}} 份</span>
                                          </div>

                                      </td>
                                      <td width=" 150px"  style="border: 1px solid #EEEEEE;    text-align: center;">
                                          <span class="orderList-table-td-money" style="">￥{{datas.orderDetails[0].amount}}</span>
                                          <span class="orderList-table-td-type" style=" ">{{datas.type_dictText}}</span>
                                      </td>
                                      <td  width=" 170px"  style="border: 1px solid #EEEEEE;">
                                        <div class="orderList-table-td-div" style=" ">
                                        <div><el-button class="orderList-table-td-button1" @click="toPay(datas.id)"  v-if="datas.orderStatus=='1'">去付款</el-button></div>
                                          <span class="orderList-table-td-view" style=""  @click="viewOrder(datas.id)" >查看详情</span>
                                          <span class="orderList-table-td-canle" style="" @click="canlOrder(datas.id)" v-if="datas.orderStatus=='1'">取消订单</span>
                                          <span class="orderList-table-td-agin" @click="againOrder(datas)" v-if="datas.orderStatus !='1'">再次购买</span>
                                        </div>
                                      </td>
                                  </tr>
                              </table>
                          </div>
                        </div>
                      </div>
                      <!-- <div  v-if="orderEndTotal>0" id="orderAllPage">
                          <el-pagination background
                            style="margin-top: 20px;float: right;margin-right: 0px;    margin-bottom: 20px;"
                              @size-change="handleSizeChange2"
                              @current-change="handleCurrentChange2"
                              :current-page="querydata2.pageNo"
                              :page-sizes="[4, 10, 20, 40]"
                              :page-size="querydata2.pageSize"
                              layout="total, sizes, prev, pager, next"
                              :total="orderEndTotal">
                          </el-pagination>
                      </div>  -->
                  </el-tab-pane>
                  <el-tab-pane label="已取消" class="wait-el-tab" name="canlePay">

                      <div v-if="!isCanleData" >
                          <el-select v-model="cancelOrderValue" width=" 67%" label="全部订单" @change="selectTimeChanged3" class="orderlist-content-select" style=" width: 200px;height: 32px;background: #FFFFFF;border: 0px solid #DDDDDD;border-radius: 2px;" >
                          <el-option
                              v-for="item in cancelTimeOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                              </el-option>
                          </el-select>
                          <el-select width=" 67%" v-model="cancelTypeValue" label="全部活动类型" @change="selectTypeChanged3" class="orderlist-content-select" style="margin-left: 10px;width: 160px;height: 32px;background: #FFFFFF;border: 0px solid #DDDDDD;border-radius: 2px;">
                            <el-option
                              v-for="item in cancelTypeOptions"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                              </el-option>
                          </el-select>
                          <el-input
                            v-model="searchContent3"
                            placeholder="商品名称/订单编号"
                            size="medium"
                            width=" 67%"
                            class="orderList-shop-search"
                            >
                            <i class="el-input__icon el-icon-search" slot="suffix" @click="searchOrder3()"/>
                          </el-input>
                      </div>
                      <div  v-if="!orderList3.length && !isCanleData"  v-loading="cancelLoading" >
                          <div   style="margin-top: 100px; margin-right: 30px;margin-bottom: 100px;" >
                            <img src="../../static/images/空.png" alt="" style="margin:0 auto;  display:block;">
                            <p class="orderList-defulat-font" >哎呀，什么都没有 T_T</p>
                          </div>
                      </div>
                      <div v-if="orderList3.length" v-loading="cancelLoading">
                          <div v-for="(datas, index) in orderList3" :key="index"   >
                              <div  style=" width: 920px;height: 40px;background: #F6F6F6;margin-top: 20px;border: 0px solid #EEEEEE;" v-if="orderList3.length">
                                <span  style="margin-left: 30px;position: absolute;margin-top: 10px;font-size: 14px;">{{datas.createTime}} </span>
                                <span style=" margin-left: 215px;position: absolute; margin-top: 10px;font-size: 14px;">订单编号：<span style="color:#333;font-size: 14px;">{{datas.orderNo}}</span> </span>
                                <img src="../../static/images/时间.png" v-if="datas.orderStatus==1" style="position: absolute;margin-left: 690px;margin-top: 12px;"/>

                                <span style=" margin-right: 140px;margin-top: 10px;float: right;color: #FF620D;font-size: 14px;font-family: PingFang SC;font-weight: 500;"  v-if="datas.orderStatus==1">{{datas.countDownTime}} </span>
                                <span class="waitPay" v-if="datas.orderStatus=='1'">{{datas.orderStatus_dictText}} </span>
                                <span class="paySUC" v-if="datas.orderStatus=='2'">{{datas.orderStatus_dictText}} </span>
                                <span class="colosePay" v-if="datas.orderStatus=='3'">{{datas.orderStatus_dictText}} </span>
                              </div>
                              <div>
                                  <table class="orderList-table" style="width: 920px;height: 110px;background: #FFFFFF;border: 1px solid #EEEEEE;" v-if="orderList3.length" >
                                        <tr style="height: 110px;border: 1px solid #EEEEEE;" >
                                            <td width=" 600px" style="border: 1px solid #EEEEEE;">
                                              <div style="float:left">
                                                  <img :src="datas.orderDetails[0].itemImgUrl" @click="openGoodsDetails(datas.orderDetails[0].serviceItemId)" class="orderList-table-td-img" >
                                                  <el-tooltip placement="right"  :open-delay="500"  :disabled="showTip2" :content='datas.orderDetails[0].serviceItemName' >
                                                    <span  class="orderList-table-td-font" @mouseenter="showTips2($event)"  @click="openGoodsDetails(datas.orderDetails[0].serviceItemId)">{{datas.orderDetails[0].serviceItemName}}</span>

                                                  </el-tooltip>
                                                  <span class="orderList-table-td-dj" >￥{{datas.orderDetails[0].unitPrice}}</span>

                                                  <span class="orderList-table-td-num" >{{datas.orderDetails[0].quantity}} 份</span>
                                              </div>
                                            </td>
                                            <td width=" 150px"  style="border: 1px solid #EEEEEE;    text-align: center; ">
                                                <span class="orderList-table-td-money" >￥{{datas.orderDetails[0].amount}}</span>
                                                <span class="orderList-table-td-type" >{{datas.type_dictText}}</span>
                                            </td>
                                            <td  width=" 170px" style="border: 1px solid #EEEEEE;" >
                                              <div class="orderList-table-td-div" >
                                                <button class="orderList-table-td-button1" @click="againOrder(datas.id)"  v-if="datas.orderStatus=='1'">去付款</button>
                                                <span class="orderList-table-td-view"   @click="viewOrder(datas.id)" >查看详情</span>
                                                <span class="orderList-table-td-canle"  @click="canlOrder(datas.id)" v-if="datas.orderStatus=='1'">取消订单</span>
                                                <span class="orderList-table-td-agin" @click="againOrder(datas)" v-if="datas.orderStatus !='1'">再次购买</span>
                                              </div>
                                            </td>
                                        </tr>
                                  </table>
                              </div>
                          </div>
                      </div>

                  </el-tab-pane>
              </el-tabs>
              <div v-if="orderList.length>0" v-show="showAllPage" id="orderAllPage">
                      <el-pagination background
                        style="margin-top: 20px; float: right;margin-right: 30px;    margin-bottom: 20px;"
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :current-page="querydata.pageNo"
                          :page-sizes="[4, 10, 20, 40]"
                          :page-size="querydata.pageSize"
                          layout="total, sizes, prev, pager, next"
                          :total="orderTotal">
                      </el-pagination>
                </div>
              <div  v-if="orderCanleTotal>0" v-show="showCanlePage" id="orderAllPage">
                      <el-pagination background
                        style="margin-top: 20px;float: right;margin-right: 30px;    margin-bottom: 20px;"
                          @size-change="handleSizeChange3"
                          @current-change="handleCurrentChange3"
                          :current-page="querydata3.pageNo"
                          :page-sizes="[4, 10, 20, 40]"
                          :page-size="querydata3.pageSize"
                          layout="total, sizes, prev, pager, next"
                          :total="orderCanleTotal">
                      </el-pagination>
                  </div>
                   <div  v-if="orderEndTotal>0" v-show="showEndPage" id="orderAllPage">
                          <el-pagination background
                            style="margin-top: 20px;float: right;margin-right: 30px;    margin-bottom: 20px;"
                              @size-change="handleSizeChange2"
                              @current-change="handleCurrentChange2"
                              :current-page="querydata2.pageNo"
                              :page-sizes="[4, 10, 20, 40]"
                              :page-size="querydata2.pageSize"
                              layout="total, sizes, prev, pager, next"
                              :total="orderEndTotal">
                          </el-pagination>
                      </div>
                      <div  v-if="orderWaitTotal > 0" v-show="showWaitPage" id="orderAllPage" >
                          <el-pagination background
                            style="margin-top: 20px; float: right;margin-right: 30px;    margin-bottom: 20px;"
                              @size-change="handleSizeChange1"
                              @current-change="handleCurrentChange1"
                              :current-page="querydata1.pageNo"
                              :page-sizes="[4, 10, 20, 40]"
                              :page-size="querydata1.pageSize"
                              layout="total, sizes, prev, pager, next"
                              :total="orderWaitTotal">
                          </el-pagination>
                        </div>
         <el-backtop  :bottom="100" style="right: auto;" >
            <div
              style="
                height: 100%;
                width: 100%;
                box-shadow: 0 0 6px rgba(0,0,0, .12);
                text-align: center;
                line-height: 40px;
                color: #1989fa; ">
              <img src="../../static/images/backtop.png" style="      margin-top: 15px;width: 20px;height: 20px;"/>
            </div>
          </el-backtop>
          <!-- <div  :class="isShowDiv ? 'order-line-init':'order-line-data'"></div> -->
          </div>
      </div>
      <div style="clear: both;height: 70px;">
      </div>
       <div style="position: fixed;left: 0px;bottom: 0px;width: 100%;z-index: -1">
            <mall-footer  ></mall-footer>
        </div>
    </div>
  </div>
</template>
<script>
import mallHeader from '../components/header.vue'
import mallFooter from '../components/footer.vue'
import mallBread from '../components/navbread.vue'
import navMenu from '../components/navMenu.vue'
import pagination from '../components/pagination.vue'
import http from '../api/public'
import axios from 'axios'
  export default {
    data () {
      return {
        orderList:[],//全部订单
        orderList1:[],//待支付
        orderList2:[],//已支付
        orderList3:[],//已取消
        searchContent:"",//搜索框
        searchContent1:"",
        searchContent2:"",
        searchContent3:"",
        waitPayCount:0,
        pageCount:0,
        allTips:false,
        showTip1:false,
        showTip2:false,
        showTip3:false,
        AllLoading: true,
        waitLoading: true,
        payLoading: true,
        cancelLoading: true,
        timeOutId:null,
        isShowDiv:false,
        isServiceError:false,
        isBackground:true,
        //用于tab 页显示默认页面的设置
        isData:true,
        isWaitData:true,
        isEndData:true,
        isCanleData:true,
        //用于各个tab 分页显示隐藏控制
        showAllPage:true,
        showWaitPage:false,
        showEndPage:false,
        showCanlePage:false,
        //全部订单
        statusOptions: [{value: '0',label: '全部状态'}, {value: '1',label: '待支付'}, {
        value: '2',label: '已支付'}, { value: '3',label: '已取消'}]
        , statusValue: '全部状态',
         timeOptions: [{ value: '0',label: '全部订单'},{ value: '1',label: '近一个月订单' }, {
          value: '2', label: '近三个月订单' }, { value: '3', label: '近半年订单'}]
          ,dateOrderValue: '全部订单',
        typeOptions: [{ value: '0',label: '全部活动类型'}, { value: '1',label: '线下购买'
        }, {value: '2',label: '在线充值'}, { value: '3', label: '活动赠送'}, {value: '4',label: '消费返点'}]
        ,typeValue: '全部活动类型',

        //待付款
         WaitTimeOptions: [{ value: '0',label: '全部订单'},{ value: '1',label: '近一个月订单' }, {
          value: '2', label: '近三个月订单' }, { value: '3', label: '近半年订单'}]
          ,WaitOrderValue: '全部订单',

        WaitTypeOptions: [{ value: '0',label: '全部活动类型'}, { value: '1',label: '线下购买'
        }, {value: '2',label: '在线充值'}, { value: '3', label: '活动赠送'}, {value: '4',label: '消费返点'}]
        ,WaitTypeValue: '全部活动类型',


          //已付款
         payTimeOptions: [{ value: '0',label: '全部订单'},{ value: '1',label: '近一个月订单' }, {
          value: '2', label: '近三个月订单' }, { value: '3', label: '近半年订单'}]
          ,payOrderValue: '全部订单',

        payTypeOptions: [{ value: '0',label: '全部活动类型'}, { value: '1',label: '线下购买'
        }, {value: '2',label: '在线充值'}, { value: '3', label: '活动赠送'}, {value: '4',label: '消费返点'}]
        ,payTypeValue: '全部活动类型',


          //已取消
         cancelTimeOptions: [{ value: '0',label: '全部订单'},{ value: '1',label: '近一个月订单' }, {
          value: '2', label: '近三个月订单' }, { value: '3', label: '近半年订单'}]
          ,cancelOrderValue: '全部订单',

        cancelTypeOptions: [{ value: '0',label: '全部活动类型'}, { value: '1',label: '线下购买'
        }, {value: '2',label: '在线充值'}, { value: '3', label: '活动赠送'}, {value: '4',label: '消费返点'}]
        ,cancelTypeValue: '全部活动类型',
        oderLists: [
        ],
        arrayTime :[],
        dayDate : 60*60*24,
        selectType:0,
        activeName: 'allOrder',//tabs 默认选中
        orderTotal:0,
        orderWaitTotal:0,
        orderEndTotal:0,
        orderCanleTotal:0,
        querydata:{
          pageNo:1,//初始显示第几页
          pageSize:4,//每页显示多少数据
          searchName:''
        },
         querydata1:{
          pageNo:1,//初始显示第几页
          pageSize:4//每页显示多少数据
        },
        querydata2:{
          pageNo:1,//初始显示第几页
          pageSize:4//每页显示多少数据
        },
         querydata3:{
          pageNo:1,//初始显示第几页
          pageSize:4//每页显示多少数据
        }
      }
    },
    created(){
        this.statusOptions.value =this.statusOptions[0].label
    },
    mounted() {
        //绑定事件
      window.addEventListener('keydown',this.callFun);
      this.getOrderData();
    },
    destroyed(){
      if(this.timeOutId) { //如果定时器在运行则关闭
            clearInterval(this.timeOutId);
        }
      window.removeEventListener('keydown',this.callFun,false);
    },
    methods: {
      //订单列表数据
      getOrderData() {
        axios.get('/mallApi/mall/order/list',{params:this.querydata ,headers:{"token": localStorage.getItem("Authorization")}}).then((res) => {
          res = res.data;
          if(res.success) {
            this.orderList = res.result.records;
            this.orderTotal =res.result.total
            if(res.result.records.length>0){
              this.isShowDiv = true;
              this.isData = false;
              this.waitPayCount=0;
              let orderDa =this.orderList;
              for(let i=0;i<orderDa.length;i++){
                // if(orderDa[i].orderStatus === "1"){
                //   this.waitPayCount++;
                // }
                orderDa[i].orderDetails.forEach(da => {
                  da.itemImgUrl =  "/mallApi"+da.itemImgUrl;
                  da.unitPrice = http.changeUnitPrice(da.unitPrice);
                  da.amount = http.changeUnitPrice(da.amount);
                });
                if (orderDa[i].orderDetails.length === 0) {
                  orderDa[i].orderDetails.push({})
                }
              }
               this.timeArray(this.orderList);
            }else{
              this.isShowDiv = false;
            }
          }else{
            if(res.code == 401|| res.code == 400) {
              http.setLocalStorge();
              this.$router.push({path: '/login'});
            }else{
              this.$message(res.message);
            }
          }
         //
        }).catch(function (error) {
          console.log('error', error)
          return Promise.reject(error)
        });
        this.AllLoading= false;
      },
      //待支付订单列表数据
      getWaitData(){
          axios.get('/mallApi/mall/order/list',{params:this.querydata1 ,headers:{"token": localStorage.getItem("Authorization")}}).then((res) => {
              res = res.data;
              if(res.success) {
               this.orderList1 = res.result.records;
                 if(res.result.records.length>0){
                    this.timeArray(this.orderList1);
                    this.isShowDiv = true;
                    this.isWaitData = false;
                  }else{
                    this.isShowDiv = false;
                     // this.isWaitData = true;
                  }

                this.orderWaitTotal =res.result.total
                let orderDa =this.orderList1;
                for(let i=0;i<orderDa.length;i++){
                  orderDa[i].orderDetails.forEach(da => {
                    da.itemImgUrl =  "/mallApi"+da.itemImgUrl;
                    da.unitPrice = http.changeUnitPrice(da.unitPrice);
                    da.amount = http.changeUnitPrice(da.amount);
                  });
                  if (orderDa[i].orderDetails.length === 0) {
                    orderDa[i].orderDetails.push({})
                  }
                }
              }else{
                if(res.code == 401 || res.code == 400 ) {
                  this.$router.push({path: '/login'});
                }else{
                  this.$message(res.message);
                }
              }

            }).catch(function (error) {
            //debugger
            console.log('error', error)
            return Promise.reject(error)
          });
          this.waitLoading= false
      },
      //已取消 列表数据
      getCanleData(){
          axios.get('/mallApi/mall/order/list',{params:this.querydata3 ,headers:{"token": localStorage.getItem("Authorization")}}).then((res) => {
            res = res.data;
            if(res.success) {
              this.orderList3 = res.result.records;
              this.orderCanleTotal =res.result.total
              let orderDa =this.orderList3;
              for(let i=0;i<orderDa.length;i++){
                orderDa[i].orderDetails.forEach(da => {
                  da.itemImgUrl =  "/mallApi"+da.itemImgUrl;
                  da.unitPrice = http.changeUnitPrice(da.unitPrice);
                  da.amount = http.changeUnitPrice(da.amount);
                });
                if (orderDa[i].orderDetails.length === 0) {
                  orderDa[i].orderDetails.push({})
                }
              }
              if(res.result.records.length>0){
                this.isShowDiv = true;
                this.isCanleData = false;
              }else{
                this.isShowDiv = false;
                // this.isCanleData  = true;
              }
            }else{
              if(res.code == 401|| res.code == 400) {
                 http.setLocalStorge();
                this.$router.push({path: '/login'});
              }else{
                this.$message(res.message);
              }
            }
          }).catch(function (error) {
          console.log('error', error)
          return Promise.reject(error)
        });
        this.cancelLoading= false;
      },
      //已支付订单列表数据
      getEndData(){
          axios.get('/mallApi/mall/order/list',{params:this.querydata2 ,headers:{"token": localStorage.getItem("Authorization")}}).then((res) => {
            res = res.data;
            if(res.success) {
            this.orderList2 = res.result.records;
             this.orderEndTotal =res.result.total
              let orderDa =this.orderList2;
              for(let i=0;i<orderDa.length;i++){
                orderDa[i].orderDetails.forEach(da => {
                  da.itemImgUrl =  "/mallApi"+da.itemImgUrl;
                  da.unitPrice = http.changeUnitPrice(da.unitPrice);
                  da.amount = http.changeUnitPrice(da.amount);
                });
                if (orderDa[i].orderDetails.length === 0) {
                  orderDa[i].orderDetails.push({})
                }
              }
              if(res.result.records.length>0){
                  this.isShowDiv = true;
                  this.isEndData = false;
                }else{
                  this.isShowDiv = false;
                  // this.isEndData = true;
                }
            }else{
              if(res.code == 401|| res.code == 400) {
                 http.setLocalStorge();
                  this.$router.push({path: '/login'});
                }else{
                  this.$message(res.message);
                }
            }
          }).catch(function (error) {
          //debugger
          console.log('error', error)
          return Promise.reject(error)
        });
          this.payLoading= false;
      },
      queryParement(){
        if(this.statusValue == "全部状态" ){
          this.statusValue ="0"
       }
        if(this.dateOrderValue == "全部订单"){
           this.dateOrderValue ='0';
        }
        if(this.typeValue == "全部活动类型"){
           this.typeValue ='0';
        }
      },
      queryParement1(){
       if(this.WaitOrderValue == "全部订单"){
          this.WaitOrderValue = '0'
        }
        if(this.WaitTypeValue == "全部活动类型"){
          this.WaitTypeValue = '0'
        }
      },
       queryParement2(){
       if(this.payOrderValue == "全部订单"){
          this.payOrderValue = '0'
        }
        if(this.payTypeValue == "全部活动类型"){
          this.payTypeValue = '0'
        }
      },
       queryParement3(){
       if(this.cancelOrderValue == "全部订单"){
          this.cancelOrderValue = '0'
        }
        if(this.cancelTypeValue == "全部活动类型"){
          this.cancelTypeValue = '0'
        }
      },queryALLdata(currentPage){
        this.querydata ={"searchName":this.searchContent,"type":this.typeValue,"timeType":this.dateOrderValue,"orderStatus": this.statusValue,"pageNo":this.querydata.pageNo,"pageSize":this.querydata.pageSize};
        if(currentPage != null){
          this.querydata.pageNo = currentPage;
        }else{
          this.querydata.pageNo = 1;
        }
        this.getOrderData();

      },
      queryWaitPaydata(currentPage){
        debugger;
        this.querydata1 ={"searchName":this.searchContent1,"timeType":this.WaitOrderValue,"type": this.WaitTypeValue,"orderStatus": "1","pageNo":this.querydata1.pageNo,"pageSize":this.querydata1.pageSize};
        if(currentPage != null){
          this.querydata1.pageNo = currentPage;
        }else{
          this.querydata1.pageNo = 1;
        }
        this.getWaitData();

      },
      queryEndPaydata(currentPage){
        this.querydata2 ={"searchName":this.searchContent2,"type":this.payTypeValue,"timeType":this.payOrderValue,"orderStatus": '2',"pageNo":this.querydata2.pageNo,"pageSize":this.querydata2.pageSize};
        if(currentPage != null){
          this.querydata2.pageNo = currentPage;
        }else{
          this.querydata2.pageNo = 1;
        }
        this.getEndData();

      },
      queryCancledata(currentPage){
        this.querydata3 ={"searchName":this.searchContent3,"type":this.cancelTypeValue,"timeType":this.cancelOrderValue,"orderStatus": '3',"pageNo":this.querydata3.pageNo,"pageSize":this.querydata3.pageSize};
        if(currentPage != null){
          this.querydata3.pageNo = currentPage;
        }else{
          this.querydata3.pageNo = 1;
        }
        this.getCanleData();

      },
      //全部订单页搜索框
      searchOrder(){
        this.queryParement();
        this.queryALLdata();
      },
      //待付款--订单搜索
      searchOrder1(currentPage){
        this.queryParement1();
        //this.queryALLdata();
        this.queryWaitPaydata(currentPage)
        //this.isWaitData = false
      },
      //已付款--订单搜索
       searchOrder2(currentPage){
       this.queryParement2();
        this.queryEndPaydata(currentPage);

      },
      searchOrder3(currentPage){
         this.queryParement3();
        this.queryCancledata(currentPage)
      },


      callFun(e){
         if(e.keyCode == 13){
            this.searchOrder();
          }
      },
      //全部订单---   订单状态搜索
      selectStatusChanged(value){
           this.queryParement();
          this.queryALLdata();
         //this.getOrderData();
           this.isData = false
      },
      //全部订单--- 订单类型搜索
      selectTypeChanged(value){
          this.queryParement();
          this.queryALLdata();
          this.isData = false
      },
      //全部订单--- 订单时间搜索
      selectTimeChanged(value){
        this.queryParement();
        this.queryALLdata();
        this.isData = false
      },


      //待付款--订单类型搜索
      selectTypeChanged1(value){
         this.searchOrder1()
         this.isWiatData = false
      },
      //待付款--订单时间搜索
      selectTimeChanged1(value){
         this.searchOrder1()
         this.isWiatData = false
      },
      //已付款--订单类型搜索
      selectTypeChanged2(value){
          this.queryParement1();
         this.getEndData();
         this.isEndData = false;
      },
      //已付款--订单时间搜索
      selectTimeChanged2(value){
         this.queryParement1();
         this.getEndData();
         this.isEndData = false;
      },

      //已取消--订单类型搜索
      selectTypeChanged3(value){

        this.searchOrder3()
        this.isCanleData = false
      },
      //已取消--订单时间搜索
      selectTimeChanged3(value){
         this.searchOrder3()
         this.isCanleData = false
      },

      //所有订单--分页当前页change 事件
      handleCurrentChange(currentPage){
        this.querydata.pageNo = currentPage;
        this.getOrderData(currentPage);
      },
      //所有订单--分页当前条数 change 事件
      handleSizeChange(pagesize){
        this.querydata.pageSize = pagesize;
        this.getOrderData();

      },
      //已取消订单--分页当前页change 事件
      handleCurrentChange3(currentPage){
        this.querydata3.pageNo = currentPage;
        this.searchOrder3(currentPage);
      },
      //已取消订单--分页当前条数 change 事件
      handleSizeChange3(pagesize){
        this.querydata3.pageSize = pagesize;
        this.searchOrder3();

      },
      //待支付--分页当前页change 事件
      handleCurrentChange1(currentPage){
        this.querydata1.pageNo = currentPage;
        this.searchOrder1(currentPage);
      },
      //待支付--分页当前条数 change 事件
      handleSizeChange1(pagesize){
        this.querydata1.pageSize = pagesize;
        this.searchOrder1();

      },
      //已支付--分页当前页change 事件
      handleCurrentChange2(currentPage){
        this.querydata2.pageNo = currentPage;
        this.searchOrder2(currentPage);
      },
      //已支付--分页当前条数 change 事件
      handleSizeChange2(pagesize){
        this.querydata2.pageSize = pagesize;
        this.searchOrder2();

      },
      //切换tab
      handleClick(tab, event) {
        //已取消
        if(tab.name =="canlePay"){
          this.searchOrder3()
          this.showAllPage = false
          this.showWaitPage=false
          this.showEndPage=false
          this.showCanlePage=true
        }else if(tab.name =="waitPay"){//待支付
            this.searchOrder1()
            this.showAllPage = false
            this.showWaitPage=true
            this.showEndPage=false
            this.showCanlePage=false
        }else if(tab.name =="endPay"){//已支付
            this.searchOrder2();
            this.showAllPage = false
           this.showWaitPage=false
            this.showEndPage=true
            this.showCanlePage=false
            //this.getEndData();
        }else{
          this.searchOrder();
          this.showAllPage = true
          this.showWaitPage=false
          this.showEndPage=false
          this.showCanlePage=false
        }

      },
      //订单商品详情
       openGoodsDetails(id){
        window.open("#/goodsDetails?id="+id);
     },
      //查看订单
      viewOrder(value){
        this.$router.push({path: '/orderDetails', query: {"orderId":value}})
      },
      //再次购买
      againOrder(value){
        //debugger
        var ids=[];
        value.orderDetails.forEach(da => {
            ids.push(
              {"quantity": da.quantity ,
              "serviceItemId": da.serviceItemId
              });
        });
        if(ids.length>0){
           axios.defaults.headers ={
            "content-type": "application/json",
            "token": localStorage.getItem("Authorization")
          }
          axios.post('/mallApi/mall/order/createByShopCarts', ids).then((res) => {
            res = res.data;
            if(res.success){
                this.$router.push({path: '/orderconfirm', query: {"orderId":res.result.id}})
            }else {
              if(res.code == 401 ||  res.code == 403 ) {
                  console.log('请登录');
                  http.setLocalStorge();
                  this.$router.push({path: '/login?path='+this.$route.fullPath});
              }else{
                this.$message({
                    showClose: true,
                    message: '操作失败！',
                    type: 'error'
                  });
              }
            }
          });
        }
          //this.$router.push({path: '/orderconfirm', query: {"orderId":value}})
      },
      //取消订单
      cancelOrderRquest(value){
         //axios.defaults.headers.put['mall-api-token'] = localStorage.getItem('Authorization');
            axios.put('/mallApi/mall/order/edit', {
                  'id': value,
                  'orderStatus':"3"
                },{headers:{"token": localStorage.getItem("Authorization")}}
              ).then(res => {
                 res = res.data;
                  if(res.success){
                    this.getOrderData();
                  }else {
                    if(res.code == 401|| res.code == 400) {
                      http.setLocalStorge();
                      this.$router.push({path: '/login'});
                    }else{
                      this.$message(res.message);
                    }
                    //console.log('请登录');
                  }
            })
      },
      //取消订单
     canlOrder(value){
        this.$confirm('您确定要取消订单吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
         this.cancelOrderRquest(value)
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
     },
     //去支付
     toPay(value){
        this.$router.push({path: '/orderconfirm', query: {"orderId":value}})
     },
     //待支付倒计时
     timeArray(data){
       if(data.length>0){
          for(let i=0;i<data.length;i++){
            if(data[i].orderStatus === "1"){
             //data[i].createTime="2020-12-20 18:31:01"
              data[i].countDownTime = "";
              this.countDown(data,i);
            }
          }
       }

     },
      //待支付倒计时
    countDown(data,i) {
      let that = this;
      let item = data[i];
      let time = 86400;
       //clearInterval(this.timeOutId); //清除定时器
      this.timeOutId = setInterval(() => {
        if (that.countDownFun(item.countDownTime,i,data) == "倒计时结束") {
          clearInterval(this.timeOutId); //清除定时器
        } else {
          item.countDownTime = that.countDownFun(item.createTime,i,data);
          that.$set(
            data,
            item.countDownTime,
            that.countDownFun(item.createTime,i,data)
          );
        }
        time = time - 1;
        if(time<1 && data.length<=0){
          clearInterval( this.timeOutId);
        }

      }, 1000);
    },
     //待支付倒计时 时间转换
    countDownFun(time,i,data) {
        let startTime = new Date().getTime()/1000; //当前时间
        let end = new Date(time).getTime()/1000; //结束时间
        let endDate  = this.dayDate+end
        let result = parseInt(endDate - startTime); //计算出豪秒
        //let d = parseInt(result / (24 * 60 * 60)); //用总共的秒数除以1天的秒数
        let h = parseInt((result / (60 * 60)) % 24); //精确小时，用去余
        let m = parseInt((result / 60) % 60); //剩余分钟就是用1小时等于60分钟进行趣余
        let s = parseInt(result % 60);
        //当倒计时结束时，改变内容
        //console.log("result:"+result);
         let re = "剩余";
        if (result <= 0 && data[i].orderStatus ==="1") {
           this.cancelOrderRquest(data[i].id);
           clearInterval( this.timeOutId);
           return "倒计时结束"
        }else{
          if (h < 10) {
            h = "0" + h;
          }else if(h <=0){
             h = "00" ;
          }
          if(m<10){
            m = '0'+m
          }else if(m <=0){
             m = "00" ;
          }

          if (s < 10) {
            s = "0" + s;
          }else if(s <=0){
             s = "00" ;
          }
          return  re += h+"时"+m + "分"+s + "秒";
        }
    },allTipsFun(obj){
        let off = obj.target.offsetHeight;
        let  sHeight = obj.currentTarget.scrollHeight;
        sHeight > off? this.allTips = false : this.allTips = true;
      },
       showTips1(obj){
        let off = obj.target.offsetHeight;
        let  sHeight = obj.currentTarget.scrollHeight;
        sHeight > off? this.showTip1 = false : this.showTip1 = true;
      },
      showTips2(obj){
        let off = obj.target.offsetHeight;
        let  sHeight = obj.currentTarget.scrollHeight;
        sHeight > off? this.showTip2 = false : this.showTip2 = true;
      },
       showTips3(obj){
        let off = obj.target.offsetHeight;
        let  sHeight = obj.currentTarget.scrollHeight;
        sHeight > off? this.showTip3 = false : this.showTip3 = true;
      },
    },

    components: {
      mallHeader,
      mallFooter,
      mallBread,
      navMenu,
      pagination,
      http
    }
  }
</script>
<style  >
.el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    background-color: rgb(246, 246, 246);
}
.el-pagination__sizes .el-input .el-input__inner:active {
    border-color: #287eff!important;
    border: 1px solid #287eff!important;
}
.el-select:hover .el-input__inner {
    border-color: #287EFF;
}
.el-input.is-active .el-input__inner, .el-input__inner:hover {
    border-color: #287EFF;
    outline: 0;
}
 input.el-input__inner{
      height: 32px;
      line-height: 32px;
}
 .el-input--medium.el-input__icon {
    line-height: 32px!important;
}
.el-input--medium .el-input__inner {
    height: 32px!important;
    line-height: 32px!important;
}
input[type="text"], input[type="number"], input[type="password"], textarea {
    padding: 1em;
    border: 1px solid #DDD;
    background: #fff;
}
.el-select .el-input.is-focus .el-input__inner {
    border-color: #287EFF;
}

.el-input.is-active .el-input__inner, .el-input__inner:focus {
    border-color: #287EFF;
    outline: 0;
}
.orderListContentData i.el-select__caret.el-input__icon.el-icon-arrow-up {
    height: 100%;
    width: 25px;
    text-align: center;
    -webkit-transition: all .3s;
    transition: all .3s;
    line-height: 32px!important;
}
.orderListContentData .el-input--medium .el-input__icon {
    line-height: 32px;
}
.order-canle-button[data-v-68e7f268]:active {
    background: rgba(40, 126, 255, 0.1);
    border: 1px solid #287EFF;
}
.order-button-again[data-v-68e7f268]:active {
    background: rgba(40, 126, 255, 0.1);
    border: 1px solid #287EFF;
    color: #287EFF;
}
.el-icon-search:hover{
  color: #287EFF
}
.el-input__suffix-inner {
    pointer-events: all;
    cursor: pointer;
}
.el-tooltip__popper {
    max-width: 500px;
    line-height: 180%;
  }


   .el-message-box__btns button.el-button:hover {
    background: rgba(40, 126, 255, 0.1);
    border: 1px solid #287EFF;
    opacity: 0.6;
    color: #287EFF;
    border-radius: 4px;
}
.el-message-box__btns button.el-button:focus{
  background: rgba(40, 126, 255, 0.1);
border: 1px solid #287EFF;
color: #287EFF;
border-radius: 4px;
}
/* .el-button.el-button--default.el-button--small:hover{
  background: rgba(40, 126, 255, 0.1);
  border: 1px solid #287EFF;
  opacity: 0.6;
  border-radius: 4px;
}
.el-button.el-button--default.el-button--small:focus{
  background: rgba(40, 126, 255, 0.1);
  border: 1px solid #287EFF;
  border-radius: 4px;
}
.el-button.el-button--default.el-button--small.el-button--primary:active{
  background: #126BF0;
}
.el-button.el-button--default.el-button--small.el-button--primary:hover{
  background: #428EFF;
} */
.el-button--primary {
    color: #FFF!important;
    background-color: #287EFF!important;
    border-color: #287EFF!important;
  }
  .el-button--primary:hover {
    background: #428EFF!important;
    color: #FFF!important;
        opacity: 1;
  }
  .el-button--primary:active {
     background: #126BF0!important;
     color: #FFF!important;
      opacity: 1;
  }
#orderAllpage input[type="text"]{
    padding: 1em;
    border: 0px solid #ccc;
    background: #fff;
}
#orderAllpage .el-pager li.number:hover{
   background-color:#EEE !important;
}
.el-select-dropdown__item.selected {
    color: #287EFF;
    font-weight: 700;
}
.el-input__inner {
   color: #333;
}


table {
  border-collapse: collapse;
  border-spacing: 0;
}
.el-tabs__nav-wrap::after {
    width: 100%;
    height: 1px;
    background-color: #E4E7ED !important;
    z-index: 1;
}
.orderListContentData div.el-backtop {
    margin-left: 1000px ;
    bottom: 50px ;
    width: 50px ;
    height: 50px ;
    opacity: 0.1;
    border-radius: 25px ;
    background: rgb(0, 0, 0) ;
}
.orderListContentData .el-backtop:hover {
  opacity: 0.2 !important;
}
.el-backtop-divs{
   height: 100%;
  width: 100%;
  box-shadow: 0 0 6px rgba(0,0,0, .12);
  text-align: center;
  line-height: 40px;
  color: #1989fa;
}
.span-css{
  align-items: center;
    position: absolute;
    width: 16px !important;
    height: 16px !important;
    border-radius: 8px;
    color: rgb(255, 255, 255);
    background-color: rgb(255, 98, 13) !important;
    font-weight: 500;
    text-align: center;
    font-size: 12px;
    margin-left: 180px;
    margin-top: 15px;
}
.orderList-header{
   overflow-x: auto; min-width: 1200px;    width: 1200px;margin: 0 auto;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: rgb(40, 126, 255)!important;
    color: rgb(255, 255, 255);
}
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
    margin: 0 5px;
    background-color: #fff;
    color: #606266;
    min-width: 30px;
    border-radius: 2px;
}
 .orderList-shop-search::-webkit-input-placeholder { /* WebKit, Blink, Edge */
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
      line-height: 20px; }

      .orderList-shop-search::-moz-placeholder { /* Mozilla Firefox 4 to 18 */
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
      line-height: 20px;}

     .orderList-shop-search ::-moz-placeholder { /* Mozilla Firefox 19+ */
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
      line-height: 20px; }

      .orderList-shop-search::-ms-input-placeholder { /* Internet Explorer 10-11 */
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
      line-height: 20px; }

.el-select el-select--mini  {
    border-color: #FFFFFF;
}
.el-message-box__btns .el-button--primary:focus, .el-button--primary:hover {
    background: #428EFF;
    border-color: #287EFF;
    color: rgb(255, 255, 255);
}
.el-message-box__status.el-icon-info {
    color: rgb(40, 126, 255);
}
/* div#orderAllPage .el-input.el-input--mini.el-input--suffix input[type="text"], input[type="number"], input[type="password"], textarea {
    padding: 1em;
    border: 1px solid #ddd;
    background: #fff;
} */
/* div#orderAllPage .el-input.el-input--mini.el-input--suffix:hover {
  border-radius: 3px;
  border: 1px solid #287EFF!important;
  background: #fff;
} */
.number:hover {
    color: #333 !important;
     background-color:#EEE !important;
}
.number.active:hover {
    color: #fff !important;
     background-color:#EEE !important;
}
.wait-el-tab{
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  line-height: 20px;
}

.el-tabs__active-bar {
  background:#287eff !important;
}
.order-line-init{
         position: absolute;
    left: 570px;
    top: 138px;
    width: 980px;
    height: 1px;
    background-color: rgb(228, 231, 237);
    z-index: 1;
}
.order-line-data{
     position: absolute;
    left: 678px;
    bottom: 329px;
    width: 980px;
    height: 1px;
    background-color: rgb(228, 231, 237);
    z-index: 1;
}
.footer__wrap {
    max-width: 1200px !important;
    margin: 0 auto;
}
.footer__inner {
    max-width: 1200px;
    margin: 0 auto;
    position: relative;
}
.el-tabs__header {
    position: relative;
    padding: 0px;
    margin: 0px ;
}
.el-tabs__item.is-active {
    color: #287eff;
    font-weight: 800;
}
.el-tabs__content {
    overflow: hidden;
    position: relative;
    margin-top: 20px!important;
    min-height: 320px;
}
  .msg-pagination-container.is-background .el-pager li {
    /*对页数的样式进行修改*/
    background-color: #10263c;
    color: #FFF;
  }
  .msg-pagination-container.is-background .btn-next {
    /*对下一页的按钮样式进行修改*/
    background-color: #10263c;
    color: #FFF;
  }
  .msg-pagination-container.is-background .btn-prev {
    /*对上一页的按钮样式进行修改*/
    background-color: #10263c;
    color: #FFF;
  }
  .msg-pagination-container.is-background .el-pager li:not(.disabled).active {
    /*当前选中页数的样式进行修改*/
    background-color: #446cff;
    color: #FFF;
  }

  .orderList-table{
    width: 920px;height: 110px;background: #FFFFFF;border: 0px solid #EEEEEE;
  }
  .orderList-table-td-img{
    margin: 20px;    width: 68px;
    height: 68px;cursor: pointer;
  }
  .orderList-table-td-font{
    cursor: pointer;
    width: 190px;
    height: 22px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333333;
    float: right;

    text-overflow: -o-ellipsis-lastline;
    line-height: 22px;
    word-wrap: break-word;
    margin-top: 45px;
    overflow: hidden;
    -webkit-line-clamp: 1;
    text-overflow: ellipsis;
    display: -webkit-box;
    /*! autoprefixer: off*/
    -webkit-box-orient:vertical;
   /* autoprefixer: on */

  }

  .orderList-table td{
        height: 110px;
        border: 1px solid rgb(238, 238, 238);
  }
  .orderList-table-td-font:hover{
    color:#287EFF
  }
  .orderList-table-td-dj{
      margin-top: 45px;position: absolute;margin-left: 240px;height: 12px;font-size: 14px;font-family: PingFang SC;font-weight: 500;color: #666666;line-height: 22px;
  }
  .orderList-table-td-num{
        margin-top: 45px;position: absolute;margin-left: 340px;height: 12px;font-size: 14px;font-family: PingFang SC;font-weight: 500;color: #666666;line-height: 22px;
  }
  .orderList-table-td-money{
        margin-top: 0px;     text-align: center;height: 13px;font-size: 16px;font-family: PingFang SC;font-weight: bold;color: #333333;line-height: 20px;
  }
  .orderList-table-td-type{
        display: block;  margin-top: 0px;height: 14px;font-size: 14px;font-family: PingFang SC;font-weight: 500;color: #666666;line-height: 20px;text-align: center;
  }
  .orderList-table-td-div{
    text-align: center;
  }
   .orderList-table-td-button1{
        width: 82px;
    height: 32px;
    background: #287EFF;
    border-radius: 4px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 20px;
  }
  .orderList-table-td-button1:hover{background: #428EFF ;}
  .orderList-table-td-button1:hover{background: #126BF0;}
  .orderList-table-td-view{
     display: block; font-size: 14px; font-family: PingFang SC; font-weight: 500;color: #333333; line-height: 20px; margin-top: 5px; text-align: center;cursor:pointer
  }
  .el-tabs__item:hover{color: #287eff}
   .orderList-table-td-view:hover{color: #287eff}
   .orderList-table-td-canle:hover{color: #287eff}
   .orderList-table-td-agin:hover{color: #287eff}
  .orderList-table-td-canle{
       font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 20px;
    cursor: pointer;
    display: block;
  }
  .orderList-table-td-agin{
    font-size: 14px;font-family: PingFang SC; font-weight: 500; color: #333333; line-height: 20px; margin-top: 0px;    cursor: pointer;
  }
.orderList-countDownTime{
  margin-right: -145px;margin-top: 10px;float: right;color: #FF620D;font-size: 14px;font-family: PingFang SC;font-weight: 500;
}

  .orderListContentInit{
    position: absolute;
   margin-left: 220px;
    margin-top: -360px;
   width: 980px;
        height: 564px;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.02);
  }
  .orderListContentData{
    /* position: absolute;
    margin-left: 220px;
    margin-top: -360px;
    width: 980px;
    height: 880px;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.02);
    margin-bottom: 60px; */
     width: 980px;
    min-width: 980px;
    margin-bottom: 60px;
    background: #FFFFFF;
    box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.02);
    overflow: auto;
    margin: 0 auto;
        float: left;
    margin-top: -360px;
    margin-left: 220px;
        min-height: 480px;
  }

  .orderList-shop-search{
    border: 0px solid #DDDDDD;
    float: right;
    width: 240px;
    height: 32px;
    background: #FFFFFF;
    border-radius: 2px;
  }
  .orderList-content-search{
        width: 240px  !important;
        height: 32px  !important;
        background: rgb(255, 255, 255) !important;
        border: 0px solid rgb(221, 221, 221) !important;
        border-radius: 2px !important;
        float: right !important;
        margin-left: -38px  !important;
  }
  .orderList-el-tabs{
    /* margin-left: 30px;
    margin-right: 30px;
    position: absolute;
    margin-top: 20px;
    width: 920px;
    background: #FFFFFF; */
      margin-left: 30px;
    margin-right: 30px;
    margin-top: 20px;
    width: 920px;
    background: #FFFFFF;
  }
  .orderList-defulat-font{
    margin-top:0px;
     font-size:14px;
      font-weight:500;
      margin-left: 380px;
  }
  .orderList-content-select{
    width: 200px !important;
    height: 32px !important;
    background: #FFFFFF!important;
    border: 0px solid #DDDDDD !important;
    border-radius: 2px!important;

  }

  .waitPay{
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FF620D;
    line-height: 20px;
    margin-right: -225px;
    margin-top: 10px;
    float: right;
  }
  .paySUC{
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #2CB308;
    line-height: 20px;
    margin-right: 20px;
    margin-top: 10px;
    float: right;
  }
  .colosePay{
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 20px;
    margin-right: 20px;
    margin-top: 10px;
    float: right;
  }

  .el-tabs__item.is-top {
      height: 30px !important;
      font-size: 16px !important;
      line-height: 0px !important;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;

  }
  .el-tabs__item.is-top.is-active{
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #333333;
  }
 #orderListId input::-webkit-input-placeholder {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
  }
  #orderListId input::-moz-input-placeholder {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
  }
  #orderListId input::-ms-input-placeholder {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #999999;
  }

</style>



// WEBPACK FOOTER //
// OrderList.vue?2ba9d77c